import { render, staticRenderFns } from "./UserSettingsPersonalAccessTokens.vue?vue&type=template&id=063266e3&scoped=true&"
import script from "./UserSettingsPersonalAccessTokens.vue?vue&type=script&lang=ts&"
export * from "./UserSettingsPersonalAccessTokens.vue?vue&type=script&lang=ts&"
import style0 from "./UserSettingsPersonalAccessTokens.vue?vue&type=style&index=0&id=063266e3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063266e3",
  null
  
)

export default component.exports